import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [
  isFetchingAttachmentsStatus,
  orderAttachments,
  selectedAttachments,
  isAttachmentsLoading,
] = createSelectors(MODULE, [
  "isFetchingAttachmentsStatus",
  "attachments",
  "selectedAttachments",
  "isAttachmentsLoading",
]);
